import React from "react";
import '../css/Quote.css';

function Quote(){
    return(
   <div className="quote">
   <p className="quote_">'It is always the simple that produces the marvellous.'</p>
   <h6>Amellia Ber</h6>
   </div>
  );
}
export default Quote;